var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowSqureDotsa8Deef14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.277,
    height: 125.167,
    viewBox: "0 0 76.277 125.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.473
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.092,29.431a5.472,5.472,0,1,0-5.466-5.472A5.468,5.468,0,0,0,119.092,29.431Z",
    transform: "translate(-48.281 -18.488)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,29.431a5.472,5.472,0,1,0-5.464-5.472A5.468,5.468,0,0,0,108.4,29.431Z",
    transform: "translate(-59.37 -18.488)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.707,29.431a5.472,5.472,0,1,0-5.465-5.472A5.469,5.469,0,0,0,97.707,29.431Z",
    transform: "translate(-70.459 -18.488)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.014,29.431a5.472,5.472,0,1,0-5.465-5.472A5.469,5.469,0,0,0,87.014,29.431Z",
    transform: "translate(-81.549 -18.488)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.092,40.646a5.472,5.472,0,1,0-5.466-5.472A5.468,5.468,0,0,0,119.092,40.646Z",
    transform: "translate(-48.281 -6.858)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,40.646a5.472,5.472,0,1,0-5.464-5.472A5.468,5.468,0,0,0,108.4,40.646Z",
    transform: "translate(-59.37 -6.858)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.707,40.646a5.472,5.472,0,1,0-5.465-5.472A5.469,5.469,0,0,0,97.707,40.646Z",
    transform: "translate(-70.459 -6.858)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.014,40.646a5.472,5.472,0,1,0-5.465-5.472A5.469,5.469,0,0,0,87.014,40.646Z",
    transform: "translate(-81.549 -6.858)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.092,51.86a5.472,5.472,0,1,0-5.466-5.472A5.468,5.468,0,0,0,119.092,51.86Z",
    transform: "translate(-48.281 4.773)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,51.86a5.472,5.472,0,1,0-5.464-5.472A5.468,5.468,0,0,0,108.4,51.86Z",
    transform: "translate(-59.37 4.773)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.707,51.86a5.472,5.472,0,1,0-5.465-5.472A5.469,5.469,0,0,0,97.707,51.86Z",
    transform: "translate(-70.459 4.773)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.014,51.86a5.472,5.472,0,1,0-5.465-5.472A5.469,5.469,0,0,0,87.014,51.86Z",
    transform: "translate(-81.549 4.773)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.092,63.074a5.472,5.472,0,1,0-5.466-5.472A5.468,5.468,0,0,0,119.092,63.074Z",
    transform: "translate(-48.281 16.403)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,63.074a5.472,5.472,0,1,0-5.464-5.472A5.468,5.468,0,0,0,108.4,63.074Z",
    transform: "translate(-59.37 16.403)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.707,63.074A5.472,5.472,0,1,0,92.241,57.6,5.468,5.468,0,0,0,97.707,63.074Z",
    transform: "translate(-70.459 16.403)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.014,63.074A5.472,5.472,0,1,0,81.549,57.6,5.468,5.468,0,0,0,87.014,63.074Z",
    transform: "translate(-81.549 16.403)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.092,74.288a5.472,5.472,0,1,0-5.466-5.472A5.468,5.468,0,0,0,119.092,74.288Z",
    transform: "translate(-48.281 28.034)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,74.288a5.472,5.472,0,1,0-5.464-5.472A5.468,5.468,0,0,0,108.4,74.288Z",
    transform: "translate(-59.37 28.034)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.707,74.288a5.472,5.472,0,1,0-5.465-5.472A5.468,5.468,0,0,0,97.707,74.288Z",
    transform: "translate(-70.459 28.034)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.014,74.288a5.472,5.472,0,1,0-5.465-5.472A5.468,5.468,0,0,0,87.014,74.288Z",
    transform: "translate(-81.549 28.034)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.092,85.5a5.472,5.472,0,1,0-5.466-5.472A5.468,5.468,0,0,0,119.092,85.5Z",
    transform: "translate(-48.281 39.664)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,85.5a5.472,5.472,0,1,0-5.464-5.472A5.468,5.468,0,0,0,108.4,85.5Z",
    transform: "translate(-59.37 39.664)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.707,85.5a5.472,5.472,0,1,0-5.465-5.472A5.469,5.469,0,0,0,97.707,85.5Z",
    transform: "translate(-70.459 39.664)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.014,85.5a5.472,5.472,0,1,0-5.465-5.472A5.469,5.469,0,0,0,87.014,85.5Z",
    transform: "translate(-81.549 39.664)",
    fill: "#fbb03b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowSqureDotsa8Deef14);
export default __webpack_public_path__ + "static/media/yellow_squre_dots.a8deef14.1d91af9592de437ef92f6a87853cdc7a.svg";
export { ForwardRef as ReactComponent };